"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordAuthVersion = exports.AuthType = void 0;
var AuthType;
(function (AuthType) {
    AuthType["PASSWORD"] = "password";
})(AuthType = exports.AuthType || (exports.AuthType = {}));
var PasswordAuthVersion;
(function (PasswordAuthVersion) {
    PasswordAuthVersion[PasswordAuthVersion["PLAIN"] = 0] = "PLAIN";
    PasswordAuthVersion[PasswordAuthVersion["BCRYPT"] = 1] = "BCRYPT";
})(PasswordAuthVersion = exports.PasswordAuthVersion || (exports.PasswordAuthVersion = {}));
